/**
 * StaticRangeTranslationService for avoiding redundant requests to the server
 * we save the results from the server on the factory
 *
 */
baseApp.service('StaticRangeTranslationService', function(){
    var staticRangeTranslationFactory ={};


    staticRangeTranslationFactory.getStaticRangeTranslationEnabled = function (accountId,callback) {
        if(staticRangeTranslationFactory[accountId]){
            return callback(staticRangeTranslationFactory[accountId].value);
        }
        else{
            /**
             * requesting from the server the if the static range translation
             * is enabled on the account via the system settings
             */
            store.fetch({
                method: 'GET',
                path: "/isStaticRangeTranslationEnabled?accountId="+accountId,
                success: function(data) {
                    staticRangeTranslationFactory[accountId] = data? {value: data} :  {value: false};
                    callback(staticRangeTranslationFactory[accountId].value);
                }
            });
        }

    };

    staticRangeTranslationFactory.updateStaticRangeTranslationEnabled = function (accountId,value) {
        staticRangeTranslationFactory[accountId] = {value: value};
    };


    return staticRangeTranslationFactory;
});
